import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./pages/agency/home/home.module').then(m => m.HomeModule),
    data: {title: 'Platfio'}
  },
  { path: 'workshops', redirectTo: '/', pathMatch: 'full' },
  { path: 'playbooks', redirectTo: '/', pathMatch: 'full' },
  { path: 'playbooks/:slug', redirectTo: '/', pathMatch: 'full' },
  {
    path: 'type',
    loadChildren: () => import('./pages/deprecated/typer/typer.module').then(m => m.TyperModule),
    data: {title: 'Select'}
  },
  {
    path: 'agenter',
    loadChildren: () => import('./pages/app/agenter/agenter.module').then(m => m.AgenterModule),
    data: {title: 'Assign'}
  },
  {
    path: 'listings',
    loadChildren: () => import('./pages/app/listings/listings.module').then(m => m.ListingsModule),
    data: {title: 'Listing'}
  },
  {
    path: 'login',
    loadChildren: () => import('./pages/agency/signin/login/login.module').then(m => m.LoginModule),
    data: {title: 'Login'}
  },
  {
    path: 'signup',
    loadChildren: () => import('./pages/agency/signin/signup/signup.module').then(m => m.SignupModule),
    data: {title: 'Signup'}
  },
  {
    path: 'signup/agency',
    loadChildren: () => import('./pages/agency/signin/signup/signup.module').then(m => m.SignupModule),
    data: {title: 'Signup'}
  },
  {
    path: 'signup/affiliate',
    loadChildren: () => import('./pages/agency/signin/signup/signup.module').then(m => m.SignupModule),
    data: {title: 'Signup'}
  },
  {
    path: 'display',
    loadChildren: () => import('./pages/deprecated/video-display/display.module').then(m => m.DisplayModule),
    data: {title: 'Display'}
  },
  {
    path: 'myapp',
    loadChildren: () => import('./pages/app/portal/myapp.module').then(m => m.MyappModule),
    data: {title: 'Portal'}
  },
  {
    path: 'support',
    loadChildren: () => import('./components/support/support.module').then(m => m.SupportModule),
    data: {title: 'Support'}
  },
  {
    path: 'help-center',
    loadChildren: () => import('./pages/agency/help/help-center.module').then(m => m.HelpCenterModule),
    data: {title: 'Help'}
  },
  {
    path: 'plan',
    loadChildren: () => import('./pages/app/plan/plan.module').then(m => m.PlanModule),
    data: {title: 'Plan'}
  },
  {
    path: 'proposal',
    loadChildren: () => import('./pages/app/proposal/proposal.module').then(m => m.ProposalModule),
    data: {title: 'Proposal'}
  },
  {
    path: 'proposal/contract',
    loadChildren: () => import('./pages/app/proposal/contract/contract.module').then(m => m.ContractModule),
    data: {title: 'Contract'}
  },
  {
    path: 'thanks',
    loadChildren: () => import('./pages/app/thanks/contact-thanks.module').then(m => m.ContactThanksModule),
    data: {title: 'Thanks'}
  },
  {
    path: 'file/:fileId',
    loadChildren: () => import('./pages/app/file-share/file-share.module').then(m => m.FileShareModule),
    data: {title: 'File'}
  },
  {
    path: 'note',
    loadChildren: () => import('./pages/app/note-view/note-view.module').then(m => m.NoteViewModule),
    data: {title: 'Note'}
  },
  {
    path: 'task',
    loadChildren: () => import('./pages/app/task-view/task-view.module').then(m => m.TaskViewModule),
    data: {title: 'Task'}
  },
  {
    path: 'myapp/tasks',
    loadChildren: () => import('./pages/app/portal/tasks/tasks.module').then(m => m.TasksModule),
    data: {title: 'Card'}
  },
  {
    path: 'privacy',
    loadChildren: () => import('./pages/app/privacy/privacy.module').then(m => m.PrivacyModule),
    data: {title: 'Privacy'}
  },
  {
    path: 'learn',
    loadChildren: () => import('./pages/deprecated/learn/learn.module').then(m => m.LearnModule),
    data: {title: 'Learn'}
  },
  {
    path: 'myapp/email/unsubscribe',
    loadChildren: () => import('./pages/app/unsubscribe/unsubscribe.module').then(m => m.UnsubscribeModule),
    data: {title: 'Unsubscribe'}
  },
  {
    path: 'myaffiliate',
    loadChildren: () => import('./pages/agency/affiliate/myaffiliate.module').then(m => m.MyaffiliateModule),
    data: {title: 'Partner'}
  },
  {
    path: 'myagency/dashboards',
    loadChildren: () => import('./pages/agency/dashboards-library/dashboard-library.module').then(m => m.DashboardLibraryModule),
    data: {title: 'Dashboards'}
  },
  {
    path: 'myagency/dashboard/:dashboardId',
    loadChildren: () => import('./pages/agency/dashboard/dashboard.page.module').then(m => m.DashboardPageModule),
    data: {title: 'Dashboard'}
  },
  {
    path: 'myagency/leads',
    loadChildren: () => import('./pages/agency/outbound/leads.module').then(m => m.LeadsModule),
    data: {title: 'Outbound'}
  },
  // {
  //   path: 'myagency/tasks',
  //   loadChildren: () => import('./pages/deprecated/tasks/team.module').then(m => m.TeamModule),
  //   data: {title: 'Tasks'}
  // },
  // {
  //   path: 'myagency/notes',
  //   loadChildren: () => import('./pages/deprecated/notes/notes.module').then(m => m.NotesModule),
  //   data: {title: 'Notes'}
  // },
  // Notifications page removed — handled via popover only
  // {
  //   path: 'notifications',
  //   loadChildren: () => import('./pages/agency/notifications/notifications.page.module').then(m => m.NotificationsPageModule),
  //   data: {title: 'Alerts'}
  // },
  {
    path: 'myagency/settings',
    loadChildren: () => import('./pages/agency/settings/settings.module').then(m => m.SettingsModule),
    data: {title: 'Account'}
  },
  {
    path: 'myagency/team',
    loadChildren: () => import('./pages/agency/settings/settings.module').then(m => m.SettingsModule),
    data: {title: 'Team'}
  },
  {
    path: 'myagency/marketing',
    loadChildren: () => import('./pages/agency/settings/settings.module').then(m => m.SettingsModule),
    data: {title: 'Marketing'}
  },
  {
    path: 'myagency/tools',
    loadChildren: () => import('./pages/agency/settings/settings.module').then(m => m.SettingsModule),
    data: {title: 'Tools'}
  },
  {
    path: 'myagency/reports',
    loadChildren: () => import('./pages/deprecated/reports/reports.module').then(m => m.ReportsModule),
    data: {title: 'Reports'}
  },
  {
    path: 'myagency/accounts',
    loadChildren: () => import('./pages/agency/developer-accounts/developers-index/myaccounts.module').then(m => m.MyaccountsModule),
    data: {title: 'Developer Accounts'}
  },
  {
    path: 'myagency/developer-appstore',
    loadChildren: () => import('./pages/agency/developer-accounts/developer-appstore/developer-appstore.module').then(m => m.DeveloperAppstoreModule),
    data: {title: 'Appstore Developer'}
  },
  {
    path: 'myagency/developer-playstore',
    loadChildren: () => import('./pages/agency/developer-accounts/developer-playstore/developer-playstore.module').then(m => m.DeveloperPlaystoreModule),
    data: {title: 'Playstore Developer'}
  },
  {
    path: 'myagency/developer-google',
    loadChildren: () => import('./pages/agency/developer-accounts/developer-google/developer-google.module').then(m => m.DeveloperGoogleModule),
    data: {title: 'Google Developer'}
  },
  {
    path: 'myagency/template/:tid',
    loadChildren: () => import('./pages/agency/autoresponders/template/template-crud.module').then(m => m.TemplateCrudModule),
    data: {title: 'Autoresponder Template'}
  },
  {
    path: 'myagency/sequence/:sid',
    loadChildren: () => import('./pages/agency/autoresponders/autoresponder/sequenc-crud.module').then(m => m.SequencCrudModule),
    data: {title: 'Autoresponder'}
  },
  {
    path: 'myagency/sender/:sid',
    loadChildren: () => import('./pages/agency/autoresponders/sender/sender-crud.module').then(m => m.SenderCrudModule),
    data: {title: 'Sender'}
  },
  {
    path: 'myagency/case-study/:csid',
    loadChildren: () => import('./pages/agency/settings/case-study-crud/case-study-crud.module').then(m => m.CaseStudyCrudModule),
    data: {title: 'Case Study'}
  },
  {
    path: 'myagency/resources/:rid',
    loadChildren: () => import('./pages/agency/help/resources/resource-detail/resource-detail.module').then(m => m.ResourceDetailModule),
    data: {title: 'Resources'}
  },
  {
    path: 'myaffiliate/resources',
    loadChildren: () => import('./pages/agency/help/resources/resources.module').then(m => m.ResourcesModule),
    data: {title: 'Resources'}
  },
  {
    path: 'myagency/landings/detail',
    loadChildren: () => import('./pages/agency/landing/landing-detail.module').then(m => m.LandingDetailModule),
    data: {title: 'Forms'}
  },
  {
    path: 'myagency/ads',
    loadChildren: () => import('./pages/agency/campaign/ads.module').then(m => m.AdsModule),
    data: {title: 'Ads'}
  },
  {
    path: 'myagency/agents/:threadId',
    loadChildren: () => import('./pages/agency/agents/agent-thread-page/agent-thread-page.module').then(m => m.AgentThreadPageModule),
    data: {title: 'Agent'}
  },
  {
    path: 'myagency/agents',
    loadChildren: () => import('./pages/agency/agents/agent-thread-page/agent-thread-page.module').then(m => m.AgentThreadPageModule),
    data: {title: 'Agent'}
  },
  {
    path: 'myagency/completions/:completionId',
    loadChildren: () => import('./pages/agency/completions/completion-detail.module').then(m => m.CompletionDetailModule),
    data: {title: 'Completion'}
  },
  {
    path: 'myagency/thread-messages/:usageEventId',
    loadChildren: () => import('./pages/agency/completions/completion-detail.module').then(m => m.CompletionDetailModule),
    data: {title: 'Thread Message'}
  },
  {
    path: 'myagency/forms/embed',
    loadChildren: () => import('./pages/deprecated/embedding/forms/forms.module').then(m => m.EFormsModule),
    data: {title: 'Forms'}
  },
  {
    path: 'myagency/forms/detail',
    loadChildren: () => import('./pages/agency/forms/form-detail.module').then(m => m.FormDetailModule),
    data: {title: 'Forms'}
  },
  {
    path: 'myagency/terms',
    loadChildren: () => import('./pages/agency/terms/terms-index/terms-index.module').then(m => m.TermsIndexModule),
    data: {title: 'My Agency Terms'}
  },
  {
    path: 'myagency/terms/:tid',
    loadChildren: () => import('./pages/agency/terms/terms-crud/terms-crud.module').then(m => m.TermsCrudModule),
    data: {title: 'My Agency Terms'}
  },
  {
    path: 'myagency/time',
    loadChildren: () => import('./pages/agency/time-tracking/time-tracking.module').then(m => m.TimeTrackingModule),
    data: {title: 'Time'}
  },
  {
    path: 'myagency/:pid/business-entities',
    loadChildren: () => import('./pages/agency/business-entities/business-entities.module').then(m => m.BusinessEntitiesModule),
    data: {title: ''}
  },
  {
    path: 'myagency/:pid/business-portal',
    loadChildren: () => import('./pages/agency/business-handover/business-handover.page.module').then(m => m.BusinessHandoverPageModule),
    data: {title: 'Portal'}
  },
  {
    path: 'myagency/:pid/business-handover',
    loadChildren: () => import('./pages/agency/business-handover/business-handover.page.module').then(m => m.BusinessHandoverPageModule),
    data: {title: 'Portal'}
  },
  {
    path: 'myagency/:pid/site-editor/:aid',
    loadChildren: () => import('./pages/app/site-editor/site-editor.module').then(m => m.SiteEditorModule),
    data: {title: 'Site Editor'}
  },
  {
    path: 'myagency/:pid/emulator',
    loadChildren: () => import('./pages/app/emulator/emulator.module').then(m => m.EmulatorModule),
    data: {title: 'Emulator'}
  },
  {
    path: 'myagency/:pid/wireframes',
    loadChildren: () => import('./pages/agency/plan/wireframes.module').then(m => m.WireframesModule),
    data: {title: 'Plan'}
  },
  {
    path: 'myagency/:pid/:prid',
    loadChildren: () => import('./pages/agency/proposal/proposal.module').then(m => m.ProposalModule),
    data: {title: 'Proposal'}
  },
  {
    path: 'myagency/:pid',
    loadChildren: () => import('./pages/agency/business/myproject.module').then(m => m.MyprojectModule),
    data: {title: 'Business'}
  },
  {
    path: 'myagency',
    loadChildren: () => import('./pages/agency/agency/myagency.module').then(m => m.MyagencyModule),
    data: {title: 'Home'}
  },
  {
    path: 'lesson/manager',
    loadChildren: () => import('./pages/staff/lessons/lessons/lessons.page.module').then(m => m.LessonsPageModule),
    data: {title: "LessonManager"}
  },
  {
    path: 'lesson/:lid',
    loadChildren: () => import('./pages/agency/help/lessons/lesson-detail/lesson-detail.module').then(m => m.LessonDetailModule),
    data: {title: 'Lesson'}
  },
  {
    path: 'agency/help/inspiration/:type/:id',
    loadChildren: () => import('./pages/agency/help/inspiration/inspiration-detail/inspiration-detail.module').then(m => m.InspirationDetailModule),
    data: {title: 'Inspiration'}
  },
  {
    path:'tools/lesson/:id',
    loadChildren: () => import('./pages/staff/lessons/lesson/lesson.page.module').then(m => m.LessonPageModule),
    data: {title: "Lesson"}
  },
  {
    path: 'appstore-support',
    loadChildren: () => import('./pages/app/appstore-support/appstore-support.module').then(m => m.AppstoreSupportModule),
    data: {title: 'Appstore Support'}
  },
  {
    path: 'embedding',
    loadChildren: () => import('./pages/deprecated/embedding/pricing-embed/pricing-embed.module').then(m => m.PricingEmbedModule),
    data: {title: 'Embedding'}
  },
  {
    path: 'card',
    loadChildren: () => import('./pages/deprecated/card-payment/card-payment.module').then(m => m.CardPaymentModule),
    data: {title: 'Card'}
  },
  {
    path: 'profile',
    loadChildren: () => import('./pages/agency/profile/profile.page.module').then(m => m.ProfilePageModule),
    data: {title: 'Profile'}
  },
  {
    path: 'task/:tid',
    loadChildren: () => import('./pages/agency/task/add-tasks.module').then(m => m.AddTasksModule),
    data: {title: 'Task'}
  },
  {
    path: 'project/:pid',
    loadChildren: () => import('./pages/agency/project/project.page.module').then(m => m.ProjectPageModule),
    data: {title: 'Project'}
  },
  {
    path: 'ticket/:tid',
    loadChildren: () => import('./pages/agency/ticket/ticket.page.module').then(m => m.TicketPageModule),
    data: {title: 'Ticket'}
  },
  {
    path: 'note/:nid',
    loadChildren: () => import('./pages/agency/note/note.page.module').then(m => m.NotePageModule),
    data: {title: 'Note'}
  },
  {
    path: 'contact/:cid',
    loadChildren: () => import('./pages/agency/contact/contact.page.module').then(m => m.ContactPageModule),
    data: {title: 'Contact'}
  },
  {
    path: 'media/:mid',
    loadChildren: () => import('./pages/agency/media/media.page.module').then(m => m.MediaPageModule),
    data: {title: 'File'}
  },
  {
    path: 'app/:aid',
    loadChildren: () => import('./pages/agency/build-app/build-app.page.module').then(m => m.BuildAppPageModule),
    data: {title: 'App'}
  },
  {
    path: 'tasks/report',
    loadChildren: () => import('./pages/deprecated/report/tasks-report/tasks-report.module').then(m => m.TasksReportModule),
    data: {title: 'Task Report'}
  },
  {
    path: 'landing',
    loadChildren: () => import('./pages/app/landing/landing.module').then(m => m.LandingDModule),
    data: {title: ''}
  },
  {
    path: 'campaigns/:cid',
    loadChildren: () => import('./pages/agency/source/source-editor.module').then(m => m.CampaignCrudModule),
    data: {title: 'Campaigns'}
  },
  {
    path: 'create',
    loadChildren: () => import('./pages/deprecated/create/create.module').then(m => m.CreateModule),
    data: {title: 'Create'}
  },
  {
    path: 'config',
    loadChildren: () => import('./pages/app/config/config.module').then(m => m.ConfigModule),
    data: {title: 'Config'}
  },
  {
    path: 'runner/:rid',
    loadChildren: () => import('./pages/agency/runner/runner.module').then(m => m.RunnerModule),
    data: {title: 'Runner'}
  },
  {
    path: 'runners/report',
    loadChildren: () => import('./pages/deprecated/report/runners-report/runners-report.module').then(m => m.RunnersReportModule),
    data: {title: 'Runner Report'}
  },
  {
    path: 'bugs/report',
    loadChildren: () => import('./pages/staff/bugs/bugs/bugs.page.module').then(m => m.BugsPageModule),
    data: {title: 'Bugs Report'}
  },
  {
    path: 'bug/:bid',
    loadChildren: () => import('./pages/staff/bugs/bug/bug.page.module').then(m => m.BugPageModule),
    data: {title: 'Bugs Report'}
  },
  {
    path: 'staff/report',
    loadChildren: () => import('./pages/deprecated/report/report.module').then(m => m.ReportModule),
    data: {title: 'Report'}
  },
  {
    path: 'staff',
    loadChildren: () => import('./pages/staff/users/users.page.module').then(m => m.UsersPageModule),
    data: {title: 'Users'}
  },
  {
    path: 'staff/tools',
    loadChildren: () => import('./pages/staff/tools/tools.page.module').then(m => m.ToolsPageModule),
    data: {title: 'Users'}
  },
  {
    path: 'staff/targets',
    loadChildren: () => import('./pages/staff/targets/targets.module').then(m => m.TargetsModule),
    data: {title: 'Targets'}
  },
  {
    path: 'staff/feedback',
    loadChildren: () => import('./pages/staff/feedback/feedback.page.module').then(m => m.FeedbackStaffModule),
    data: {title: 'Feedback'}
  },
  {
    path: 'tools/helper',
    loadChildren: () => import('./pages/staff/helpers/helpers/helper.page.module').then(m => m.HelperPageModule),
  },
  {
    path:'helper/:hid',
    loadChildren: () => import('./pages/staff/helpers/helper/helper.page.module').then(m => m.HelperPageModule),
  },
  {
    path: 'staff/machines',
    loadChildren: () => import('./pages/staff/machines/machines.page.module').then(m => m.MachinesPageModule),
    data: {title: 'Machines'}
  },
  {
    path: 'staff/sync-staging',
    loadChildren: () => import('./pages/staff/sync-staging/sync-staging.page.module').then(m => m.SyncStagingPageModule),
    data: {title: 'Sync Staging'}
  },
  {
    path: 'staff/prompts',
    loadChildren: () => import('./pages/staff/prompts/prompts/prompts.page.module').then(m => m.PromptsPageModule),
    data: {title: 'Prompts'}
  },
  {
    path: 'staff/prompts/:id',
    loadChildren: () => import('./pages/staff/prompts/prompt/prompt.page.module').then(m => m.PromptPageModule),
    data: {title: 'Prompt'}
  },
  // manager and crud
  {
    path: 'tools/announcements',
    loadChildren: () => import('./pages/staff/announcements/announcements/announcements.page.module').then(m => m.AnnouncementsPageModule),
    data: {title: 'Announcements'}
  },
  {
    path: 'tools/announcement/:aid',
    loadChildren: () => import('./pages/staff/announcements/announcement/announcement.page.module').then(m => m.AnnouncementPageModule),
    data: {title: 'Announcement'}
  },
  // index and detail
  {
    path: 'announcements/announcement-detail',
    loadChildren: () => import('./pages/agency/help/announcements/announcement-detail/announcement-detail.module').then(m => m.AnnouncementDetailModule),
    data: {title: 'Announcement'}
  },
  {
    path: 'media',
    loadChildren: () => import('./pages/deprecated/media-view/media-view.module').then(m => m.MediaViewModule),
    data: {title: 'Media'}
  },
  {
    path: 'packages',
    loadChildren: () => import('./pages/agency/packages/packages/packages.module').then(m => m.PackagesModule),
    data: {title: 'Packages'}
  },
  {
    path: 'package/:pid',
    loadChildren: () => import('./pages/agency/packages/package/package.module').then(m => m.PackageModule),
    data: {title: 'Package'},
  },
  {
    path: 'package/:pid/assets/:aid',
    loadChildren: () => import('./pages/agency/packages/assets/assets.module').then(m => m.AssetsModule),
    data: {title: 'Assets'}
  },
  {
    path: 'announcements',
    loadChildren: () => import('./pages/agency/help/announcements/announcement-index/announcement-index.module').then(m => m.AnnouncementIndexModule),
    data: {title: 'Announcements'}
  },
  {
    path: 'releases',
    loadChildren: () => import('./pages/staff/releases/releases/releases.page.module').then(m => m.ReleasesPageModule),
    data: {title: 'Releases'}
  },
  {
    path: 'release/:rid',
    loadChildren: () => import('./pages/staff/releases/release/release.page.module').then(m => m.ReleasePageModule),
    data: {title: 'Releases'}
  },
  {
    path: 'resources',
    loadChildren: () => import('./pages/staff/resources/resource/resource.page.module').then(m => m.ResourcePageModule),
    data: {title: 'Resources'}
  },
  {
    path: 'resource/:rid',
    loadChildren: () => import('./pages/staff/resources/resources/resources.page.module').then(m => m.ResourcesPageModule),
    data: {title: 'Resources'}
  },
  {
    path: 'resources/type/:rid',
    loadChildren: () => import('./pages/staff/resource-types/resource-type/resource-type.page.module').then(m => m.ResourceTypePageModule),
    data: {title: 'Resources'}
  },
  {
    path: 'resources/typelist',
    loadChildren: () => import('./pages/staff/resource-types/resource-types/resource-types.page.module').then(m => m.ResourceTypesPageModule),
    data: {title: 'Resources'}
  },
  {
    path: 'term',
    loadChildren: () => import('./pages/staff/terms/term/term.page.module').then(m => m.TermPageModule),
    data: {title: 'Terms'}
  },
  {
    path: 'term/:tid',
    loadChildren: () => import('./pages/staff/terms/terms/terms.page.module').then(m => m.TermsPageModule),
    data: {title: 'Terms'}
  },
  {
    path: 'funnel/:fid',
    loadChildren: () => import('./pages/agency/funnel/funnel-crud.module').then(m => m.FunnelCrudModule),
    data: {title: 'Funnel'}
  },
  {
    path: 'product/:uid',
    loadChildren: () => import('./pages/agency/product/product-crud/product-crud.module').then(m => m.ProductCrudModule),
    data: {title: 'Product'}
  },
  {
    path: 'plan/:uid',
    loadChildren: () => import('./pages/agency/product/plan/plans-crud.module').then(m => m.PlansCrudModule),
    data: {title: 'Plan'}
  },
  {
    path: 'lessontype',
    loadChildren: () => import('./pages/staff/lesson-types/lesson-types/lesson-types.page.module').then(m => m.LessonTypesPageModule),
    data: {title: 'LessonType'}
  },
  {
    path: 'lessontype/:lid',
    loadChildren: () => import('./pages/staff/lesson-types/lesson-type/lesson-type.page.module').then(m => m.LessonTypePageModule),
    data: {title: 'LessonType'}
  },
  {
    path: 'lessontag',
    loadChildren: () => import('./pages/staff/tags/tags/tags.page.module').then(m => m.TagsPageModule),
    data: {title: 'LessonTag'}
  },
  {
    path: 'lessontag/:lid',
    loadChildren: () => import('./pages/staff/tags/tag/tag.page.module').then(m => m.TagPageModule),
    data: {title: 'LessonTag'}
  },
  {
    path: 'flowtemplates',
    loadChildren: () => import('./pages/staff/flow-templates/flow-templates/flow-templates.page.module').then(m => m.FlowTemplatesPageModule),
    data: {title: 'Flow Templates'}
  },
  {
    path: 'flowtemplate/:tid',
    loadChildren: () => import('./pages/staff/flow-templates/flow-template/flow-template.page.module').then(m => m.FlowTemplatePageModule),
    data: {title: 'Flow Template'}
  },
  {
    path: 'cold-message-manager',
    loadChildren: () => import('./pages/agency/prompts/cold-message-manager/cold-message-manager.module').then(m => m.ColdMessageManagerModule),
    data: {title: 'ColdMessage'}
  },
  {
    path: 'cold-message-crud/:cid',
    loadChildren: () => import('./pages/agency/prompts/cold-message-crud/cold-message-crud.module').then(m => m.ColdMessageCrudModule),
    data: {title: 'ColdMessage'}
  },
  {
    path: 'test-index/:uid',
    loadChildren: () => import('./pages/app/tests/test-index/test-index.module').then(m => m.TestIndexModule),
  },
  {
    path: 'manual-test-crud',
    loadChildren: () => import('./pages/app/tests/manual-test-crud/manual-test-crud.module').then(m => m.ManualTestCrudModule),
  },
  {
    path: 'manual-test-crud/:mtid',
    loadChildren: () => import('./pages/app/tests/manual-test-crud/manual-test-crud.module').then(m => m.ManualTestCrudModule),
  },
  {
    path: 'automated-test-crud',
    loadChildren: () => import('./pages/app/tests/automated-test-crud/automated-test-crud.module').then(m => m.AutomatedTestCrudModule),
  },
  {
    path: 'automated-test-crud/:atid',
    loadChildren: () => import('./pages/app/tests/automated-test-crud/automated-test-crud.module').then(m => m.AutomatedTestCrudModule),
  },
  {
    path: 'test-results/:tid',
    loadChildren: () => import('./pages/app/tests/test-result/test-result.module').then(m => m.TestResultModule),
  },
  {
    path:'test-results/:tid/:trid',
    loadChildren: () => import('./pages/app/tests/test-result-detail/test-result-detail.module').then(m => m.TestResultDetailModule),
  },
  {
    path: 'signup/agency/onboarding',
    loadChildren: () => import('./pages/agency/onboarding/onboarding.module').then(m => m.OnboardingModule),
    data: {title: 'Onboarding'}
  },
  {
    path: 'myapp/wizard',
    loadChildren: () => import('./pages/app/wizard/wizard.module').then(m => m.WizardModule)
  },
  {
    path: 'myapp/note',
    loadChildren: () => import('./pages/agency/note/note.module').then(m => m.NoteModule)
  },
  { path: 'ads', loadChildren: () => import('./pages/agency/campaign/ads.module').then(m => m.AdsModule) },
  {
    path: 'axipapp',
    loadChildren: () => import('./pages/app/axipapp/axipapp.module').then(m => m.AxipappModule),
    data: {title: 'AxipApp - Rebranded to Platfio'}
  },
  // redirects for legacy paths
  { 
    path: 'contact', 
    redirectTo: '/', 
    pathMatch: 'full',
  },
  { 
    path: 'support/thanks', 
    redirectTo: '/thanks', 
    pathMatch: 'full',
  },
  {
    path: 'contact/thanks', 
    redirectTo: '/thanks', 
    pathMatch: 'full',
  },
  {
    path: 'tools/lessons',
    redirectTo: 'lesson/manager',
    pathMatch: 'full',
  },
  // redirects for wordpress changeover
  { path: 'about-us', redirectTo: '/', pathMatch: 'full' },
  { path: 'partnerships-2', redirectTo: '/', pathMatch: 'full' },
  { path: 'case-studies', redirectTo: '/business', pathMatch: 'full' },
  { path: 'app-development-cost', redirectTo: '/', pathMatch: 'full' },
  { path: 'blogs', redirectTo: '/', pathMatch: 'full' },
  { path: 'book-appointment', redirectTo: '/help-center?tab=bookings', pathMatch: 'full' },
  { path: 'contact', redirectTo: '/signup', pathMatch: 'full' },
  { path: 'contact-thankyou', redirectTo: '/thanks', pathMatch: 'full' },
  { path: 'features', redirectTo: '/', pathMatch: 'full' },
  { path: 'automation', redirectTo: '/', pathMatch: 'full' },
  { path: 'bookings', redirectTo: '/', pathMatch: 'full' },
  { path: 'content', redirectTo: '/', pathMatch: 'full' },
  { path: 'counters', redirectTo: '/', pathMatch: 'full' },
  { path: 'data', redirectTo: '/', pathMatch: 'full' },
  { path: 'ecommerce', redirectTo: '/', pathMatch: 'full' },
  { path: 'forms', redirectTo: '/', pathMatch: 'full' },
  { path: 'crm', redirectTo: '/', pathMatch: 'full' },
  { path: 'integrations', redirectTo: '/', pathMatch: 'full' },
  { path: 'marketing', redirectTo: '/', pathMatch: 'full' },
  { path: 'pages', redirectTo: '/', pathMatch: 'full' },
  { path: 'subscription', redirectTo: '/', pathMatch: 'full' },
  { path: 'tools', redirectTo: '/', pathMatch: 'full' },
  { path: 'partnerships', redirectTo: '/', pathMatch: 'full' },
  { path: 'platfio', redirectTo: '/', pathMatch: 'full' },
  { path: 'platform-2', redirectTo: '/', pathMatch: 'full' },
  { path: 'examples', redirectTo: '/business', pathMatch: 'full' },
  { path: 'gymappoffer', redirectTo: '/business/gym', pathMatch: 'full' },
  { path: 'business/custom-apps', redirectTo: '/business/custom-app', pathMatch: 'full' },
  { path: 'business/gymapp', redirectTo: '/business/gym', pathMatch: 'full' },
  { path: 'business/mortgagebrokerapp', redirectTo: '/business/mortgage-broker', pathMatch: 'full' },
  { path: 'business/coachingapp', redirectTo: '/business/coaching-app', pathMatch: 'full' },
  { path: 'business/financialplannerapp', redirectTo: '/business/financial-planner', pathMatch: 'full' },
  { path: 'business/insurancebrokerapp', redirectTo: '/business/insurance-broker', pathMatch: 'full' },
  { path: 'business/ecommerceapp', redirectTo: '/business/ecommerce-app', pathMatch: 'full' },
  { path: 'business/restaurantapp', redirectTo: '/business/restaurant', pathMatch: 'full' },
  { path: 'business/cafeapp', redirectTo: '/business/cafe-app', pathMatch: 'full' },
  { path: 'business/salonapp', redirectTo: '/business/beauty-salon', pathMatch: 'full' },
  { path: 'business/accountantapp', redirectTo: '/business/accountant-app', pathMatch: 'full' },
  { path: 'business/clinicapp', redirectTo: '/business/healthcare-clinic', pathMatch: 'full' },
  // these need to be after the redirects to avaoid conflicts
  {
    path: 'business',
    loadChildren: () => import('./pages/app/home/index/business-index.module').then(m => m.BusinessIndexModule),
    data: {title: 'Businesses'}
  },
  {
    path: 'business/signin',
    loadChildren: () => import('./pages/app/home/auth/business-auth.module').then(m => m.BusinessAuthModule),
    data: {title: 'Signin'}
  },
  {
    path: 'business/signup',
    loadChildren: () => import('./pages/app/home/auth/business-auth.module').then(m => m.BusinessAuthModule),
    data: {title: 'Signup'}
  },
  {
    path: 'business/not-found',
    loadChildren: () => import('./pages/app/home/not-found/business-not-found.module').then(m => m.BusinessNotFoundModule),
    data: {title: 'Not Found'}
  },
  {
    path: 'business/:id',
    loadChildren: () => import('./pages/app/home/detail/business-detail.module').then(m => m.BusinessDetailModule),
    data: {title: 'Business Details'}
  },
  {
    path: 'business/:id/get-started',
    loadChildren: () => import('./pages/app/home/auth/business-auth.module').then(m => m.BusinessAuthModule),
    data: {title: 'Get Started'}
  },
  // match all not found
  {
    path: '**',
    loadChildren: () => import('./pages/agency/not-found/notfound.module').then(m => m.NotfoundModule),
    data: {title: 'Not Found'}
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    initialNavigation: 'enabledBlocking',
    scrollPositionRestoration: 'top',
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
